import { axios } from '../interceptors';
import { Plan, SwitchData } from '../models';

class SwitchService {
  private static baseUrl = '/switch';

  public static getPlanChartData = async (stateCode: string, planCode: string) => {
    const response = await axios.get<Plan>(`${this.baseUrl}/charts`, {
      params: {
        stateCode,
        planCode,
      },
    });
    return response.data;
  };

  public static postSwitchData = async (
    postData: SwitchData,
  ) => {
    const response = await axios.post(
      `${this.baseUrl}`,
      postData,
    );
    return response.status;
  };
}

export { SwitchService };
